<template>
  <g>
    <border />
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="15"
      x="6"
      y="5"
      viewBox="0 0 14 15"
      fill="none"
    >
      <path
        d="M7.00914 14.4868C3.53327 14.4868 0.700195 11.6537 0.700195 8.17786C0.700195 4.94007 3.21187 2.20222 6.43776 1.90463V1.66656H5.37833C5.05694 1.66656 4.79505 1.40468 4.79505 1.08328C4.79505 0.761881 5.05694 0.5 5.37833 0.5H8.59232C8.91372 0.5 9.1756 0.761881 9.1756 1.08328C9.1756 1.40468 8.91372 1.66656 8.59232 1.66656H7.60432V1.90463C8.72326 2.01176 9.78269 2.40459 10.6755 3.04738L11.0921 2.63076L10.9373 2.47601C10.7112 2.24984 10.7112 1.88082 10.9373 1.65465C11.0445 1.54752 11.1992 1.488 11.354 1.488C11.5087 1.488 11.6516 1.54752 11.7706 1.65465L12.9014 2.7855C13.0086 2.89264 13.0681 3.04738 13.0681 3.20213C13.0681 3.35688 13.0086 3.49972 12.9014 3.61876C12.7943 3.72589 12.6515 3.78541 12.4848 3.78541C12.3182 3.78541 12.1872 3.72589 12.0682 3.61876L11.9134 3.46401L11.5563 3.82112C12.6991 4.99958 13.33 6.54706 13.33 8.20167C13.3181 11.6537 10.485 14.4868 7.00914 14.4868ZM7.00914 3.03548C4.16416 3.03548 1.85485 5.34479 1.85485 8.18976C1.85485 11.0347 4.16416 13.344 7.00914 13.344C9.85411 13.344 12.1634 11.0347 12.1634 8.18976C12.1634 5.34479 9.85411 3.03548 7.00914 3.03548Z"
        fill="#394858"
      />
      <path
        d="M7.00955 8.67788C6.68815 8.67788 6.42627 8.416 6.42627 8.1065V5.09488C6.42627 4.77348 6.68815 4.5116 7.00955 4.5116C7.33095 4.5116 7.59283 4.77348 7.59283 5.09488V7.51132H9.09269C9.41409 7.51132 9.67597 7.7732 9.67597 8.0946C9.67597 8.416 9.41409 8.67788 9.09269 8.67788H7.00955Z"
        fill="#394858"
      />
    </svg>
  </g>
</template>

<script>
  import Border from './_border';
  export default {
    components: {
      Border
    }
  };
</script>
